(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swiper"] && !Shopify.designMode) return;
  try {
    
const productswiper = new Swiper('.productSwiper', {
  slidesPerView: 3,
  centeredSlides: true,
  spaceBetween: 30,
  loop: true,
  navigation: {
    nextEl: '.productSwiper-button-next',
    prevEl: '.productSwiper-button-prev',
  },
  breakpoints: {
    320: { slidesPerView: 1.3, centeredSlides: true, spaceBetween: 20 },
    576: { slidesPerView: 2, centeredSlides: true },
    992: { slidesPerView: 3, centeredSlides: true },
    1200: { slidesPerView: 3, centeredSlides: true }
  }
});

  } catch(e) { console.error(e); }
})();
})();
